import React from 'react';

import { ActiveFacetsContainer } from 'src/components/organisms/ActiveFacets/ActiveFacetsContainer';
import { DynamicFacetPillsContainer } from 'src/components/organisms/DynamicFacetPills/DynamicFacetPillsContainer';
import { ListingsControlsSideBar } from 'src/components/organisms/ListingsControlsSideBar/ListingsControlsSideBar';
import { ListingsHeaderContainer } from 'src/components/organisms/ListingsHeader/ListingsHeaderContainer';
import { ProductPagesContainer } from 'src/components/organisms/ProductPages/containers/ProductPagesContainer';
import * as elementIds from 'src/constants/elementIds';
import * as styles from './ListingsLayout.styles';

interface ListingsLayoutProps {
  children?: React.ReactNode;
  stickyTopBanner?: boolean;
}

export const ListingsLayout = ({ children, stickyTopBanner = false }: ListingsLayoutProps) => {
  return (
    <div css={styles.listingsLayoutRoot} id={elementIds.PRODUCT_CONTAINER_WRAPPER}>
      <div css={styles.listingsLayoutFacetPills}>
        <DynamicFacetPillsContainer />
      </div>
      <ActiveFacetsContainer />
      <ListingsHeaderContainer stickyTopBanner={stickyTopBanner} />
      <div css={styles.listingLayoutGrid}>
        <main css={styles.listingsLayoutProducts}>
          <ProductPagesContainer />
        </main>
        <div css={styles.listingsLayoutSidebar}>
          <ListingsControlsSideBar />
        </div>
        <div css={styles.listingsLayoutFooter}>{children}</div>
      </div>
    </div>
  );
};
